import dayjs from '$/utils/dayjs';

// Mirrors (does not import) the backend's own implementation at
// server/supabase/functions/_shared/utils/dayjs/calendarDays.ts. The
// frontend deliberately owns a separate copy rather than reaching into the
// backend submodule for this one utility, so the two sides stay decoupled;
// both follow the same UTC-safe algorithm and the same test-case matrix —
// keep them in sync by hand if either changes.

export type CalendarDay = {
  day: number;
  date: string;
  weekday: string;
  display_date: string;
};

/**
 * Deterministically maps each trip day number to its real calendar date and
 * weekday, computed from the arrival date alone. Always parsed as a UTC
 * calendar date (never local time) so a naive "YYYY-MM-DD" string can never
 * shift to the wrong day. Never sourced from LLM-generated content.
 */
export function buildTripCalendar(arrivalDate: string, numberOfDays: number): CalendarDay[] {
  const arrival = dayjs.utc(arrivalDate).startOf('day');

  if (!arrival.isValid() || numberOfDays <= 0) return [];

  return Array.from({ length: numberOfDays }, (_, index) => {
    const date = arrival.add(index, 'day');

    return {
      day: index + 1,
      date: date.format('YYYY-MM-DD'),
      weekday: date.format('dddd'),
      display_date: date.format('dddd, D MMMM YYYY'),
    };
  });
}
